import { render, staticRenderFns } from "./BranchForm.vue?vue&type=template&id=2ad5671e&scoped=true&"
import script from "./BranchForm.vue?vue&type=script&lang=js&"
export * from "./BranchForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad5671e",
  null
  
)

export default component.exports